import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/htx/lab-procedures/alkalinePhosphatase";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	alkalinePhosphatase: {
		id: "form.alkaline_phosphatase",
		defaultMessage: "Alkalikus foszfatáz"
	},
	value: {
		id: "form.alkaline_phosphatase.value",
		defaultMessage: "Érték"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["value"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.value }] }]
};

export const node: LeafNode = {
	id: "alkalinePhosphatase",
	value: {
		title: messages.alkalinePhosphatase,
		validator,
		fieldset,
		isImportant: true
	}
};
